(function () {
  'use strict';

  const overlay = document.getElementById('SearchOverlay');
  if (!overlay) return;
  const input = document.getElementById('SearchInput');
  const defaultPane = document.getElementById('SearchDefault');
  const resultsPane = document.getElementById('SearchResults');
  const viewAll = document.getElementById('SearchViewAll');

  // Money formatter for predictive search (Shopify gives "8.90"/"€8.90" depending on shop)
  function formatMoney(raw) {
    if (raw == null) return '';
    if (typeof raw === 'string') return raw;
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(raw / 100);
  }

  function esc(s) { return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function highlight(text, q) {
    if (!q || !text) return text || '';
    try {
      return String(text).replace(new RegExp('(' + esc(q) + ')', 'gi'), '<mark>$1</mark>');
    } catch (_) {
      return String(text);
    }
  }

  function productHTML(p, q) {
    const img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
    const price = p.price !== undefined ? formatMoney(p.price) : (p.price_min_formatted || '');
    const category = p.product_type || p.vendor || '';
    return ''
      + '<a href="' + (p.url || '#') + '" class="search-product">'
      + (img ? '<img src="' + img + '" alt="" class="search-product__img" loading="lazy">' : '<div class="search-product__img"></div>')
      + '<div class="search-product__info">'
      + '<div class="search-product__cat">' + (category || '&nbsp;') + '</div>'
      + '<div class="search-product__title">' + highlight(p.title, q) + '</div>'
      + '<div class="search-product__price">' + price + '</div>'
      + '</div></a>';
  }

  function renderResults(q, data) {
    const products = (data && data.products) || [];
    const collections = (data && data.collections) || [];
    const pages = (data && data.pages) || [];
    const articles = (data && data.articles) || [];
    const total = products.length + collections.length + pages.length + articles.length;

    resultsPane.style.display = 'grid';
    resultsPane.style.gridColumn = '1 / -1';
    resultsPane.style.gridTemplateColumns = '1fr 1.8fr';
    resultsPane.style.gap = '60px';

    if (total > 0) {
      viewAll.style.display = 'inline-flex';
      viewAll.href = '/search?q=' + encodeURIComponent(q);
      viewAll.innerHTML = 'Alle <strong style="color:var(--color-gold-dark); margin: 0 6px;">' + total + '</strong> Treffer für &quot;' + q + '&quot; ansehen '
        + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" style="width:14px;height:14px;"><path d="M5 12h14M13 5l7 7-7 7"/></svg>';
    } else {
      viewAll.style.display = 'none';
    }

    if (total === 0) {
      resultsPane.innerHTML = ''
        + '<div class="search-empty">'
        + '<p class="search-empty__ornament">✦ ─── ─── ✦</p>'
        + '<h3 class="search-empty__title">Keine Treffer für &quot;<em>' + q + '</em>&quot;</h3>'
        + '<p class="search-empty__sub">Versuch ein anderes Stichwort oder schau in unseren Kollektionen vorbei.</p>'
        + '</div>';
      return;
    }

    let html = '<div>';
    if (collections.length) {
      html += '<h3 class="search-col__title">Kollektionen</h3><ul class="search-cats">';
      html += collections.map(c =>
        '<a href="' + (c.url || '#') + '" class="search-cat">'
          + '<span>' + highlight(c.title, q) + '</span>'
          + '<span class="search-cat__count">' + (c.products_count != null ? c.products_count + ' Produkte' : '') + '</span>'
        + '</a>'
      ).join('');
      html += '</ul>';
    }
    const auxiliary = pages.concat(articles);
    if (auxiliary.length) {
      html += '<h3 class="search-col__title" style="margin-top:32px;">Seiten &amp; Hilfe</h3><div class="search-pages">';
      html += auxiliary.map(p =>
        '<a href="' + (p.url || '#') + '" class="search-page">'
          + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" style="width:16px;height:16px;color:var(--color-gold-dark);"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/></svg>'
          + highlight(p.title, q)
          + '<span class="search-page__type">' + (p.object_type === 'article' ? 'Artikel' : 'Seite') + '</span>'
        + '</a>'
      ).join('');
      html += '</div>';
    }
    html += '</div><div>';
    if (products.length) {
      html += '<h3 class="search-col__title">Produkte '
        + '<span style="margin-left:auto; font-family:var(--font-ui); font-size:11px; color:var(--color-muted); text-transform:none; letter-spacing:0.04em;">'
        + products.length + ' Treffer</span></h3>';
      html += '<div class="search-products">' + products.map(p => productHTML(p, q)).join('') + '</div>';
    } else {
      html += '<h3 class="search-col__title">Produkte</h3>'
        + '<p style="font-family:var(--font-display); font-style:italic; font-size:17px; color:var(--color-muted); padding:20px 0;">Keine direkten Produkttreffer — schau in den passenden Kollektionen.</p>';
    }
    html += '</div>';
    resultsPane.innerHTML = html;
  }

  // Fetch from Shopify Predictive Search API
  let lastQuery = '';
  async function search(q) {
    const query = q.trim();
    if (!query) {
      defaultPane.style.display = 'contents';
      resultsPane.style.display = 'none';
      resultsPane.innerHTML = '';
      viewAll.style.display = 'none';
      lastQuery = '';
      return;
    }
    if (query === lastQuery) return;
    lastQuery = query;

    defaultPane.style.display = 'none';
    if (!resultsPane.innerHTML) {
      resultsPane.style.display = 'grid';
      resultsPane.innerHTML = '<p class="search-loading">Suche…</p>';
    }

    try {
      const url = '/search/suggest.json'
        + '?q=' + encodeURIComponent(query)
        + '&resources[type]=product,collection,page,article'
        + '&resources[limit]=10'
        + '&resources[options][unavailable_products]=last'
        + '&resources[options][fields]=title,product_type,variants.title,tag,vendor';
      const r = await fetch(url, { headers: { 'Accept': 'application/json' } });
      if (!r.ok) throw new Error('search failed');
      const data = await r.json();
      if (lastQuery !== query) return; // outdated
      renderResults(query, (data.resources && data.resources.results) || {});
    } catch (err) {
      resultsPane.innerHTML = '<div class="search-empty"><p class="search-empty__sub">Suche fehlgeschlagen — bitte erneut versuchen.</p></div>';
    }
  }

  function openOverlay() {
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => input.focus(), 100);
  }
  function closeOverlay() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    input.value = '';
    search('');
  }

  // Open via any element with aria-label="Suche" (header icon button/link)
  document.querySelectorAll('[aria-label="Suche"]').forEach((el) => {
    if (el === overlay || el.closest('#SearchOverlay')) return;
    el.addEventListener('click', (e) => {
      e.preventDefault();
      openOverlay();
    });
  });

  overlay.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', closeOverlay));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeOverlay();
    if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') {
      e.preventDefault();
      openOverlay();
    }
  });

  let debounce;
  input.addEventListener('input', (e) => {
    clearTimeout(debounce);
    debounce = setTimeout(() => search(e.target.value), 120);
  });

  // Quick-chip queries
  overlay.addEventListener('click', (e) => {
    const chip = e.target.closest('[data-query]');
    if (chip) {
      input.value = chip.dataset.query;
      search(chip.dataset.query);
      input.focus();
    }
  });
})();
